import React from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import getRoute from '@root/src/services/routeList';
import { textPBold } from '@features/ui/styles/textStyles';
import Button, { BUTTON_VARIANT } from '@features/ui/components/Button';
import { ICON_NAME } from '@features/ui/components/Icon';
import Banner from '@features/ui/components/Banner';

const BannerLogin = () => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <StyledBanner>
      <BannerContent>
        <div>{t('eventSubscription_bannerPleaseLogin.message')}</div>
        <Button
          url={getRoute.openModal(router).login()}
          variant={BUTTON_VARIANT.primary}
          text={t('eventSubsciption_buttonTextLogin.message')}
          leftIcon={ICON_NAME.accountCircle}
          urlScroll={false}
        />
      </BannerContent>
    </StyledBanner>
  );
};

export default BannerLogin;

const StyledBanner = styled(Banner)`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
`;
const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  >:first-child {
    ${textPBold};
    margin-bottom: 20px;
  }
`;
